import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  userData: {},
  incomeData: {},
};

const formSlice = createSlice({
  name: "form",
  initialState,
  reducers: {
    setUserFormData(state, action) {
      state.userData = action.payload;
    },
    setIncomeData(state, action) {
      state.incomeData = action.payload;
    },
  },
});

export const { setUserFormData, setIncomeData } = formSlice.actions;
export default formSlice.reducer;
